module.exports = __webpack_public_path__ + "media/images/orange-sunburst-1df46e0249da87adf86cf80c9149302d.png";